






















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductTab, Product, ProductTabTypeChange } from '@/models/Product';
import ProductInfoTab from './TabContent/ProductInfoTab.vue';
import DocumentTab from './TabContent/DocumentTab.vue';
import SpecificationTab from './TabContent/SpecificationTab.vue';
import Specification2Tab from './TabContent/Specification2Tab.vue';
import VariantsTab from './TabContent/VariantsTab.vue';
import Variants2Tab from './TabContent/Variants2Tab.vue';
import SimilarProductsTab from './TabContent/SimilarProductsTab.vue';
import BathroomColorsTab from './TabContent/BathroomColorsTab.vue';
import RelatedVariantsTab from './TabContent/RelatedVariantsTab.vue';
import { ProductTabStore } from '@/store/producttabstate';

@Component({
    components: {
        ProductInfoTab,
        DocumentTab,
        SpecificationTab,
        Specification2Tab,
        VariantsTab,
        Variants2Tab,
        SimilarProductsTab,
        BathroomColorsTab,
        RelatedVariantsTab
    }
})
export default class TabsPortrait extends Vue {
    @Prop()
    protected productTabs!: ProductTab[];
    @Prop()
    protected productItemNumber!: string;

    protected productTabsCopy!: ProductTab[];

    constructor() {
        super();

        this.productTabsCopy = JSON.parse(JSON.stringify(this.productTabs));

        this.productTabsCopy.forEach(e => {
            if (e.Selected) {
                e.Selected = false;
            }
        });
    }

    @Watch('getSelectedTabType')
    private stateSelectedTabType() {
        const tab = this.getSelectedTabType;
        if (tab != null) {
            this.productTabsCopy.forEach(element => {
                if (element.TabType == tab.TabType) {
                    element.Selected = true;

                    if (tab.Scroll) {
                        this.scrollTo('product-tab-portrait-7');
                    }
                }
            });
        }
    }

    get getSelectedTabType(): ProductTabTypeChange {
        return ProductTabStore.getSelectedTabTypePortrait;
    }

    private scrollTo(id: any) {
        const element = document.getElementById('product-tab-portrait-7');
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    }
}
